import palette from '../palette';

export default {
  root: {
    padding: '20px',
    fontSize: '18px',
    fontWeight: 'normal',
    borderBottom: `1px solid ${palette.divider}`
  }
};
